import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './components/auth/AuthProvider';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import CategoriesPage from './pages/CategoriesPage';
import CollectionsPage from './pages/CollectionsPage';
import ShopsPage from './pages/ShopsPage';
import MessagingPage from './pages/MessagingPage';
import WaitlistPage from './pages/WaitlistPage';

// Pages placeholder (à créer plus tard)
const UsersPage = () => (
  <div className="animate-in">
    <h1 className="text-3xl font-bold text-white mb-2">Utilisateurs</h1>
    <p className="text-surface-400">Gestion des utilisateurs de la plateforme</p>
    <div className="card p-8 mt-6 text-center text-surface-500">
      <p>🚧 Page en cours de développement</p>
    </div>
  </div>
);

const RolesPage = () => (
  <div className="animate-in">
    <h1 className="text-3xl font-bold text-white mb-2">Rôles & Permissions</h1>
    <p className="text-surface-400">Configuration des droits d'accès</p>
    <div className="card p-8 mt-6 text-center text-surface-500">
      <p>🚧 Page en cours de développement</p>
    </div>
  </div>
);

const AnalyticsPage = () => (
  <div className="animate-in">
    <h1 className="text-3xl font-bold text-white mb-2">Analytics</h1>
    <p className="text-surface-400">Statistiques et rapports</p>
    <div className="card p-8 mt-6 text-center text-surface-500">
      <p>🚧 Page en cours de développement</p>
    </div>
  </div>
);

const SettingsPage = () => (
  <div className="animate-in">
    <h1 className="text-3xl font-bold text-white mb-2">Paramètres</h1>
    <p className="text-surface-400">Configuration du système</p>
    <div className="card p-8 mt-6 text-center text-surface-500">
      <p>🚧 Page en cours de développement</p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Route publique - Login */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Routes protégées */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/categories" element={<CategoriesPage />} />
                    <Route path="/collections" element={<CollectionsPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/roles" element={<RolesPage />} />
                    <Route path="/shops" element={<ShopsPage />} />
                    <Route path="/messaging" element={<MessagingPage />} />
                    <Route path="/waitlist" element={<WaitlistPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                  </Routes>
                </MainLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
        
        <ToastContainer
          position="bottom-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </AuthProvider>
    </Router>
  );
}

export default App;
